export default function locate(value, fromIndex) {
    return value.indexOf('++', fromIndex);
}